import React from 'react';
import Pin from '../../button/pin/pin';
import Icon from '../../icon/icon';

import './pdfDocumentControls.scss';

interface PdfDocumentControlsInterface {
  onBackClick?: any;
  expandClick?: () => void;
  collapseClick?: () => void;
  expand: boolean;
  onDownload?: any;
  onPrint?: any;
  onZoomOut?: any;
  zoom?: any;
  onZoomIn?: any;
  onPreviousPage?: any;
  page?: any;
  numPages?: any;
  onNextPage?: any;
  onPin?: () => void;
  pinned?: boolean;
  shouldPin?: boolean;
  backgroundColor?: string;
}

const PdfDocumentControls: React.FC<PdfDocumentControlsInterface> = ({
  expand,
  onBackClick,
  collapseClick,
  expandClick,
  onDownload,
  onPrint,
  onZoomOut,
  zoom,
  onZoomIn,
  onPreviousPage,
  page,
  numPages,
  onNextPage,
  onPin,
  pinned,
  shouldPin,
  backgroundColor,
}) => {
  return (
    <div className="pdf-controls" style={{ background: backgroundColor }}>
      <div>
        <div className="controls">
          <div className="btnGroup hidden-mobile">
            <span className="pointer dividerRight" onClick={onDownload}>
              <Icon name={'fa-regular fa-file-download'} />
            </span>
          </div>
          <div className="btnGroup hidden-mobile">
            <span className="pointer dividerRight " onClick={onPrint}>
              <Icon name={'fa-regular fa-print'} />
            </span>
          </div>

          <div className="btnGroup">
            <span className="pointer iconButton" onClick={onZoomOut}>
              <Icon name={'fa-regular fa-search-minus'} />
            </span>

            <div className="light noPadding center-text">{Math.round(zoom * 100)} %</div>

            <span className="pointer iconButton" onClick={onZoomIn}>
              <Icon name={'fa-regular fa-search-plus'} />
            </span>
          </div>

          <div className="btnGroup margin10l">
            <span className="pointer" onClick={onPreviousPage}>
              <Icon name={'fa-regular fa-chevron-left'} />
            </span>
            <span>
              <span className="noPadding">{page} </span> <span className="light noPadding">/ </span> <span className="light noPadding"> {numPages}</span>
            </span>
            <span className="pointer" onClick={onNextPage}>
              <Icon name={'fa-regular fa-chevron-right'} />
            </span>
          </div>
          <div className="btnGroup hidden-mobile">
            <span className="pointer dividerRight " onClick={onPin}>
              {shouldPin ? <Pin isPinned={pinned} /> : null}
            </span>
          </div>

          <div className="side-controls">
            {expand ? (
              <div className="btnGroup">
                <span className="pointer">
                  <Icon onClick={collapseClick} name={'fa-regular fa-compress'} className={'expand-compress'} />
                </span>
              </div>
            ) : (
              <div className="btnGroup">
                <span className="pointer">
                  <Icon onClick={expandClick} name={'fa-regular fa-expand'} className={'expand-compress'} />
                </span>
              </div>
            )}
            <div className="btnGroup">
              <span className="pointer">
                <Icon onClick={onBackClick} name={'fa-solid fa-circle-xmark'} className={'close-doc'} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfDocumentControls;
